import React, {useMemo} from "react";
import styled from "styled-components";
import {observer} from "mobx-react";
import {DotLottiePlayer} from "../lottie-player/dot-lottie-player.component";
import {AnimatedTopImageWrapper} from "./boxes/animated-top-image-wrapper";

const LottieTopImageWrapper = styled(AnimatedTopImageWrapper)`
    svg {
        display: block;
    }
`;

export interface AnimatedTopImageComponentProps {
    image: string;
}
export const LottieAnimatedTopImageComponent: React.FC<AnimatedTopImageComponentProps> = observer((props) => {
    const styles = useMemo(() => ({}), []);
    return <LottieTopImageWrapper>
        <DotLottiePlayer
            src={props.image}
            autoplay
            loop
            style={styles}
        />
    </LottieTopImageWrapper>;
});
